import IdLessRestService from "./IdLessRestService";


export default class Spouse extends IdLessRestService {
    constructor() {
        super('/api/userprofile/account/spouse' )
    }

}
